export default "__VITE_ASSET__15638435__"